/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type DataType = typeof DataType[keyof typeof DataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataType = {
  Asset: 'Asset',
  Consumption: 'Consumption',
  KeyFigures: 'KeyFigures',
} as const;
